<template lang="pug">
    div
        multiselect.select(
            v-model="selected",
            :multiple="true",
            :close-on-select="false",
            :clear-on-select="false",
            :options="options",
            :show-labels="true",
            deselect-label="X",
            select-label="mit Enter auswählen",
            selected-label="ausgewählt",
            :placeholder="filter.name",
            :aria-expanded="isOpen.toString()",
            aria-controls="listbox-id",
            role="combobox",
            @open="isOpen = true",
            @close="isOpen = false"
        )
        //- Unsichtbare Liste für aria-controls-Beziehung (nicht für Anzeige notwendig)
        ul#listbox-id(role="listbox", style="display: none;")
            li(v-for="option in options", :key="option", role="option") {{ option }}
</template>

<script>
import Multiselect from 'vue-multiselect'
import get from 'lodash.get'

export default {
    name: "Select",
    components: {
        Multiselect
    },
    data() {
        return {
            selectedValues: '',
            isOpen: false // <-- für aria-expanded
        }
    },
    props: {
        filter: {
            type: Object,
            required: true
        },
    },
    computed: {
        selected: {
            get() {
                return this.selectedValues
            },
            set(value) {
                this.selectedValues = value;
                let key = this.filterKey;
                let payload = { key, value };
                this.$emit('changedFilter', payload)
            }
        },
        options() {
            let options = []
            this.filter.pages.forEach(page => {
                options.push(get(page.pivot, 'value'))
            })
            options = options.filter((value, index) => options.indexOf(value) === index).sort();
            if (this.filter.key === 'alter') {
                options.forEach((item, i) => {
                    if (item === '<18' || item === '>18') {
                        options.splice(i, 1);
                        options.unshift(item);
                    }
                });
            }
            return options;
        },
        filterKey() {
            return this.filter.key;
        }
    }
}
</script>

<style lang="sass" scoped>
    .custom-select
        width: 100%
</style>